import as from 'ansis'

/** Generate a login success message */
export function loggedInMessage(userIdentifier?: string | null) {
  /**
   * User identifier is not shown in CI to avoid exposing
   * platform user information in public repositories.
   */
  if (process.env.CI || !userIdentifier)
    return 'Successfully authenticated to Scalar CLI'

  return `Successfully authenticated to Scalar CLI as ${as.cyan(userIdentifier)}`
}
